import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo, useState } from "preact/hooks";
import { productImagePlaceholder, fallbackColorsForSwatches, clearanceCategoriesArr } from "../helpers"

export default function Product({ product, index }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    // console.log(product);
    

    const categoriesAttributeValue = product?.categories?.join(" & ");
    // badges
    const isClearanceBadge = product?.categoryIds?.some(categoryId => clearanceCategoriesArr.includes(categoryId));
    const isBulkBadge = product?.categories?.includes("Specials & Clearance/Bulk Savings");
    const isExclusiveBadge = product?.categories?.includes("Specials & Clearance/Bundles + Free Tools");
    const isMadeInUsaBadge = product?.categories?.includes("Specials & Clearance/Made in the USA");
    const isNewBadge = product?.categories?.includes("Specials & Clearance/New Arrivals");
    const isBestsellerBadge = product?.customFields?.find(field => field?.key === "is hot")?.value === "Yes";
    const isVideoBadge = product?.customFields?.find(field => field?.key === "has video")?.value === "Yes";
    // ------
    const isPriceHidden = product?.customFields?.find(field => field?.key === "price hidden")?.value === "Yes";
    const atcText = isPriceHidden ? "Add to Cart to See Price" : product?.availability === "OutOfStock" ? "out of stock" : "add to cart";

    // color variations --------------
    const globalColorSwatches = window.colorsForSwatches;
    let colorPairs;
    if(window.colorsForSwatches){
        colorPairs = window.colorsForSwatches;
    } else {
        colorPairs = fallbackColorsForSwatches;
    }

    // const colorGroups = useMemo(() => {


    //     return product?.skus?.reduce((acc, sku) => {
    //             // console.log(sku);
    //             const color = sku?.customFields?.find(field => field?.key === "color")?.value;
    //             const skuAvailability = sku?.availability;
    //             if (color && skuAvailability !== "OutOfStock" && colorPairs[color]) {
    //                 // acc[color] = acc[color] || [];
    //                 // acc[color].push(sku);
    //                 acc.push(sku)
    //             }
    //             return acc;
    //     }, [])  
    // }, []);
    const colorGroups = useMemo(() => {
        const uniqueColors = new Set();
      
        return product?.skus?.reduce((acc, sku) => {
          const color = sku?.customFields?.find(field => field?.key === "color")?.value;
          const skuAvailability = sku?.availability;
      
          if (color && skuAvailability !== "OutOfStock" && colorPairs[color] && !uniqueColors.has(color)) {
            uniqueColors.add(color);
            acc.push(sku);
          }
      
          return acc;
        }, []);
      }, [product?.skus, colorPairs]); 
    // console.log(product.skus.length, colorGroups.length)

    // console.log('colorGroups', colorGroups);
    const [productImg, setProductImg] = useState(product?.thumbUrl);
    const numberOfAvailableSkus = product?.skus?.filter(sku => sku?.availability === "InStock")?.length;

    
    // console.log(isClearanceBadge, isBulkBadge);
    // console.log(product?.categories);
    // console.log(product);
    return (
        <SerpElement
            as="li"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="ns-product product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit ns-col-12 ns-col-xs-6 ns-col-l-3 ns-p-2 ns-my-0 ns-my-l-2 ns-mx-0"
        >
            <article class="card" data-event-type="list" data-entity-id={product?.productId} data-position={index} data-name={product?.name} data-product-category={categoriesAttributeValue} data-product-brand={product?.brand} data-product-price={product?.price} data-test={`card-${product?.productId}`}>
                <figure class="card-figure">
                    {isClearanceBadge ? <div class="nosto__badge nosto__pill-badge nosto__clearance-badge ns-font-bold ns-font-4">CLEARANCE</div> :
                    isBulkBadge ? <img class="nosto__badge" src="https://store-f4083.mybigcommerce.com/content/badges/badge-jbtools-bulk-savings.png" /> :
                    isExclusiveBadge ? <div class="nosto__badge nosto__pill-badge nosto__exclusive-badge ns-font-bold ns-font-4">EXCLUSIVE</div> :
                    isMadeInUsaBadge ? <img class="nosto__badge" src="https://store-f4083.mybigcommerce.com/content/badges/badge-jbtools-made-in-usa.png"></img> :
                    isNewBadge ? <div class="nosto__badge nosto__pill-badge nosto__new-badge ns-font-bold ns-font-4">NEW</div> :
                    isBestsellerBadge ? <div class="nosto__badge nosto__pill-badge nosto__bestseller-badge ns-font-bold ns-font-4">BEST SELLER</div> : 
                    isVideoBadge ? <img class="nosto__badge" src="https://store-f4083.mybigcommerce.com/content/badges/badge-jbtools-video.png" /> : ''}
                    <a href={product?.url} data-event-type="product-click" class="card-figure__link" aria-label={product?.name}>
                        <div class="card-img-container">
                            {/* <img class="card-image lazyautosizes ls-is-cached lazyloaded" src="https://cdn11.bigcommerce.com/s-f4083/images/stencil/500x659/products/216265/473410/25126__27130.1.jpg" alt="OEMTOOLS 7/8 Inch Nut Splitting Tool, Manual Nut Breaker (25126)" title="OEMTOOLS 7/8 Inch Nut Splitting Tool, Manual Nut Breaker (25126)" data-sizes="auto" data-src="https://cdn11.bigcommerce.com/s-f4083/images/stencil/500x659/products/216265/473410/25126__27130.1.jpg" loading="lazy" sizes="251px" /> */}
                            <img class="card-image lazyautosizes ls-is-cached lazyloaded" src={productImg} alt={product?.name} title={product?.name} data-sizes="auto" data-src={productImg} loading="lazy" sizes="251px" />
                        </div>
                    </a>
                    {/* <figcaption class="card-figcaption">
                        <div class="card-figcaption-body"><button type="button" class="button button--small card-figcaption-button quickview custom-quick-view-card" data-product-id={product?.productId}>Quick view</button></div>
                    </figcaption> */}
                </figure>
                <div class="card-body">
                    {product?.skus?.length > 1 && colorGroups.length > 0 ? (
                        <div class="list-options card-option is-loaded">
                        <div class="form-field" style="margin: 0px; text-align: center;">
                            {colorGroups.map((sku, index) =>{
                                // console.log(sku);
                                const skuColor = sku?.customFields?.find(field => field.key === "color")?.value;
                                return (
                                <label class={`nosto__variant nosto__variant--${skuColor.toLowerCase()} nosto__pointer form-option form-option-swatch`} data-product-swatch-value={sku?.id} data-title={skuColor} onClick={() => setProductImg(sku?.imageUrl)}>
                                    <span class="form-option-tooltip">{skuColor}</span>
                                    <span class="form-option-variant form-option-variant--color" title={skuColor} style={`background-color: ${colorPairs[skuColor]};`}></span>
                                </label>
                            )
                            })}
                        </div>
                    </div>
                    ) : numberOfAvailableSkus > 5 ? (
                        <div class="ns_variations_count">{`(5+ Options Available)`}</div>
                    ) : numberOfAvailableSkus > 1 ? (
                        <div class="ns_variations_count">{`(${numberOfAvailableSkus} Variations Available)`}</div>
                    ) : ''}
                    <h3 class="card-title" name={product?.productId}>
                        <a href={product?.url} aria-label={product?.name}>{product?.name}</a>
                    </h3>
                    <div class="card_rate">
                        <div class="yotpo bottomLine yotpo-small" data-product-id={product?.productId} data-url={product?.url}>
                        </div>
                    </div>
                    {!isPriceHidden && (<div class="card-text card_price nosto__result__pricing" data-test-info-type="price">
                        {product?.listPrice > product?.price && (
                            <div class="price-section price-section--withoutTax rrp-price--withoutTax nosto-list-price">
                                <span data-product-rrp-price-without-tax="true" class="price price--rrp">{format(product?.listPrice)}</span>
                            </div>
                        )}
                        <div class="price-section price-section--withoutTax nosto__result__price">
                            <span class="price-label"></span>
                            <span class="price-now-label" style="display: none;"></span>
                            <span data-product-price-without-tax="true" class="price price--withoutTax">{format(product?.price)}</span>
                        </div>
                    </div>)}
                    <div class={`custom-top-card-button ${isPriceHidden ? "ns-price-hid-button" : ""}`}>
                        <a class={`btn button button--small card-figcaption-button ns-atc ${product?.availability === "OutOfStock" ? "ns-oos" : ""}`}
                        href={`/cart.php?action=add&product_id=${product?.productId}`} data-event-type="product-click" data-button-type="add-cart">{atcText}</a>
                        <span class="product-status-message aria-description--hidden">The item has been added</span>
                    </div>
                    <button type="button" data-product-id={product?.productId} class="button button--small card-figcaption-button quickview custom-quick-view-card moved-quick-view ns-quickview">Quick view</button>
                </div>
            </article>
        </SerpElement>
    )
}
